import type { TextPropView } from '@consta/uikit/Text'
import type { TextFieldProps } from '@consta/uikit/TextField'
import { TextField } from '@consta/uikit/TextField'
import type { Nullable } from '@library/types'
import type { FC } from 'react'

import { SettingContainer } from './SettingContainer'

type SettingTextProps = {
  className?: string
  state?: TextFieldProps<'text'>['state']
  label: string
  value: Nullable<string>
  errorText?: string
  placeholder?: string
  onChange: (value: Nullable<string>) => void
  disabled?: boolean
  view?: TextPropView
}

export const SettingText: FC<SettingTextProps> = ({
  onChange,
  label,
  value,
  className,
  placeholder,
  errorText,
  state,
  disabled,
  view,
}) => {
  return (
    <SettingContainer className={className} label={label} view={view}>
      <TextField
        size="xs"
        placeholder={placeholder}
        state={state}
        value={value}
        caption={errorText}
        status={errorText !== undefined ? 'alert' : undefined}
        withClearButton={true}
        disabled={disabled}
        onChange={onChange}
      />
    </SettingContainer>
  )
}
